export default "__VITE_ASSET__574b0adc__"